import React from 'react';
import { Link } from "react-router-dom";
import styles from "./HomeHero.module.css";
import templateImage from "./assets/temp.PNG";

export default function HomeHero() {
  return (
    <section
      className={styles.hero}
      style={{ backgroundImage: `url(${templateImage})` }}
    >

      <div className={styles.overlay}></div>

      <div className={styles.content}>
        <h1>
          Gemeinsam lernen.
          <br />
          Zukunft gestalten.
        </h1>

        <p>
          Willkommen an der IKS – Interkulturelle Schule Rhein-Main.
          Wir fördern Talente und begleiten unsere Schüler.
        </p>

        <div className={styles.buttons}>
          <Link to="/bildungsangebote/igsgrundstufe" className={styles.btnSecondary}>
            Lernen Sie uns kennen!
          </Link>
        </div>
      </div>

      <svg
        className={styles.wave}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
      >
        <path
          fill="#ffffff"
          d="M0,192L60,197.3C120,203,240,213,360,197.3C480,181,600,139,720,138.7C840,139,960,181,1080,192C1200,203,1320,181,1380,170.7L1440,160L1440,320L0,320Z"
        />
      </svg>

    </section>
  );
}